import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

/* ─── Column data ─────────────────────────────────────────────── */
const QUICK_CONTACTS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about-us" },
  { label: "Menu", to: "/menu" },
  { label: "Franchise", to: "/franchise" },
  { label: "Career", to: "/career" },
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms & Conditions", to: "/terms-and-conditions" },
];

const TOP_MENUS = [
  { label: "Double Marinated Grill Chicken", to: "/menu" },
  { label: "Delicious Briyani", to: "/menu" },
  { label: "Tandoori Special", to: "/menu" },
  { label: "Arabian Delight", to: "/menu" },
  { label: "Soups", to: "/menu" },
  { label: "Indian Breads", to: "/menu" },
];

const SERVICES = [
  { label: "Outdoor Catering", to: "/outdoor-catering" },
  { label: "Barbequeen Express", to: "/barbequeen-express" },
  { label: "Events", to: "/events" },
  { label: "Fun Activities", to: "/fun-activities" },
  { label: "Awards & Achievements", to: "/awards-achievements" },
  { label: "Order Online", to: "/menu" },
];

/* ─── Social Icon SVGs ─────────────────────────────────────────── */
const FacebookIcon = () => (
  <svg
    className="w-4 h-4 fill-current"
    viewBox="0 0 24 24"
    xmlns="http://w3.org/2000/svg"
  >
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const InstagramIcon = () => (
  <svg
    className="w-4 h-4 fill-current"
    viewBox="0 0 24 24"
    xmlns="http://w3.org/2000/svg"
  >
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);

const YoutubeIcon = () => (
  <svg
    className="w-4 h-4 fill-current"
    viewBox="0 0 24 24"
    xmlns="http://w3.org/2000/svg"
  >
    <path d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg
    className="w-4 h-4 fill-current"
    viewBox="0 0 24 24"
    xmlns="http://w3.org/2000/svg"
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

/* ─── Column heading ───────────────────────────────────────────── */
const ColHeading = ({ children }) => (
  <h3 className="text-white font-bold text-[15px] tracking-wide mb-5 relative pb-3 after:absolute after:bottom-0 after:left-0 after:w-10 after:h-0.5 after:bg-[#9b1c2e]">
    {children}
  </h3>
);

/* ─── Footer Component ─────────────────────────────────────────── */
const Footer = () => {
  return (
    <footer className="bg-[#000000] text-gray-300">
      {/* ── Main Footer Body ── */}
      <div className="max-w-[1280px] mx-auto px-4 lg:px-8 pt-14 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10">
          {/* ── Col 1: Logo + Socials (3 cols) ── */}
          <div className="lg:col-span-3 flex flex-col gap-6">
            {/* Logo */}
            <Link to="/" aria-label="Barbequeen Home" className="inline-block">
              <img
                src={logo}
                alt="Barbequeen — The Love of Delicacies"
                className="h-16 w-auto object-contain brightness-0 invert"
              />
            </Link>

            {/* Tagline */}
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs">
              Authentic Indian BBQ &amp; grill experience. Crafted with love,
              served with passion — from our kitchen to your table.
            </p>

            {/* Social Icons */}
            <div>
              <p className="text-[11px] text-gray-500 uppercase tracking-widest font-semibold mb-3">
                Connect With Us
              </p>
              <div className="flex gap-3">
                <a
                  href="https://facebook.com/BarbequeenRestaurant/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="w-9 h-9 rounded-md bg-[#9b1c2e]/60 hover:bg-[#9b1c2e] text-white flex items-center justify-center transition-all duration-200 hover:scale-110"
                >
                  <FacebookIcon />
                </a>
                <a
                  href="https://instagram.com/barbequeenrestaurant/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="w-9 h-9 rounded-md bg-[#9b1c2e]/60 hover:bg-[#9b1c2e] text-white flex items-center justify-center transition-all duration-200 hover:scale-110"
                >
                  <InstagramIcon />
                </a>
                <a
                  href="https://youtube.com/@barbequeenrestaurant"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                  className="w-9 h-9 rounded-md bg-[#9b1c2e]/60 hover:bg-[#9b1c2e] text-white flex items-center justify-center transition-all duration-200 hover:scale-110"
                >
                  <YoutubeIcon />
                </a>
                <a
                  href="https://wa.me/919597228788"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp"
                  className="w-9 h-9 rounded-md bg-[#9b1c2e]/60 hover:bg-[#9b1c2e] text-white flex items-center justify-center transition-all duration-200 hover:scale-110"
                >
                  <WhatsAppIcon />
                </a>
              </div>
            </div>
          </div>

          {/* ── Col 2: Quick Contacts (2 cols) ── */}
          <div className="lg:col-span-2">
            <ColHeading>Quick Contacts</ColHeading>
            <ul className="list-none space-y-2.5">
              {QUICK_CONTACTS.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-gray-400 hover:text-white hover:pl-1.5 transition-all duration-200 block"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Col 3: Our Top Menus (3 cols) ── */}
          <div className="lg:col-span-3">
            <ColHeading>Our Top Menus</ColHeading>
            <ul className="list-none space-y-2.5">
              {TOP_MENUS.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-gray-400 hover:text-white hover:pl-1.5 transition-all duration-200 block"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Col 4: Our Services (2 cols) ── */}
          <div className="lg:col-span-2">
            <ColHeading>Our Services</ColHeading>
            <ul className="list-none space-y-2.5">
              {SERVICES.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-gray-400 hover:text-white hover:pl-1.5 transition-all duration-200 block"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Col 5: Head Office (2 cols) ── */}
          <div className="lg:col-span-2">
            <ColHeading>Head Office</ColHeading>
            <address className="not-italic text-sm text-gray-400 leading-relaxed space-y-3">
              <div className="flex gap-2.5">
                <svg
                  className="w-4 h-4 text-[#9b1c2e] flex-shrink-0 mt-0.5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <span>
                  <strong className="text-gray-200 font-semibold block text-[12px] uppercase tracking-wider mb-1">
                    Nonvee Foods Private Limited
                  </strong>
                  # 32, Valmiki Street,
                  <br />
                  Near Ramakrishna Higher
                  <br />
                  Secondary School,
                  <br />
                  Subramaniya Nagar,
                  <br />
                  Salem – 636 005.
                </span>
              </div>
            </address>
          </div>
        </div>
      </div>

      {/* ── Divider ── */}
      <div className="border-t border-white/10" />

      {/* ── Bottom Copyright Bar ── */}
      <div className="max-w-[1280px] mx-auto px-4 lg:px-8 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-[12px] text-gray-500">
          <p>
            © {new Date().getFullYear()} Barbequeen by{" "}
            <span className="text-gray-400 font-medium">
              Nonvee Foods Private Limited
            </span>
            . All Rights Reserved.
          </p>
          <div className="flex items-center gap-5">
            <Link
              to="/privacy-policy"
              className="hover:text-white transition-colors duration-200"
            >
              Privacy Policy
            </Link>
            <span className="text-white/20">|</span>
            <Link
              to="/terms-and-conditions"
              className="hover:text-white transition-colors duration-200"
            >
              Terms &amp; Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
